//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { formatDate } from '@/utils/date.js';
import { fetchLostList, fetchLostCreate } from '@/api/PMS/customerService/lostAndFound/queryList';
export default {
  props: ['keyValue', 'showDialog'],
  data: function data() {
    return {
      rules: {
        receiveUserName: [{
          required: true,
          message: '请输入领取人姓名',
          trigger: 'blur'
        }],
        receiveUserPhone: [{
          required: true,
          message: '请输入领取人联系方式',
          trigger: 'blur'
        }],
        receiveUserAdder: [{
          required: true,
          message: '请输入领取人住址',
          trigger: 'blur'
        }],
        receiveDate: [{
          required: true,
          message: '请输入领取人时间',
          trigger: 'blur'
        }]
      },
      goodsIdList: [],
      goodsList: [],
      childData: {}
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
    this.goodsList = [];
    this.goodsIdList = [];
  },
  methods: {
    init: function init() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });
      this.goodsList = [];
      this.goodsIdList = [];
      this.getList();
      this.childData = {};
      this.$set(this.childData, 'receiveDate', formatDate(new Date(), 'yyyy-MM-dd hh:mm'));
    },
    getList: function getList() {
      var _this2 = this;

      fetchLostList({
        id: this.keyValue
      }).then(function (res) {
        _this2.goodsList = res.data.data;
      });
    },
    handCreate: function handCreate() {
      var _this3 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this3.goodsIdList.length < 1) {
            _this3.Alert({
              alertType: 'valid',
              message: '领取物品不能为空'
            });

            return;
          }

          if (_this3.keyValue > 0) {
            _this3.childData.goodsLostAndFoundId = _this3.keyValue;
            _this3.childData.goodsIdList = _this3.goodsIdList;
            fetchLostCreate(_this3.childData).then(function (res) {
              if (res.data.code === 200) {
                _this3.$emit('handCancle', true);

                _this3.Alert({
                  alertType: 'update'
                });
              }
            });
          }
        } else {
          _this3.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};